import { render, staticRenderFns } from "./RdLoadingButton.vue?vue&type=template&id=2c381980&scoped=true&"
import script from "./RdLoadingButton.vue?vue&type=script&lang=ts&"
export * from "./RdLoadingButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c381980",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
